module.exports = __webpack_public_path__ + "static/media/gallery (4).ef615893.jpg";